import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import pageConfig from '@PROJECT_ROOT/responsiveFrontendPagesConfiguration.json';
import HomeContent from '@PROJECT_ROOT/assets/responsive-frontend/pages/Home/HomeContent';
import GlobalPageComponents from '@PROJECT_ROOT/assets/responsive-frontend/js/parts/globalPageComponents';
import initAfterContentComponent from '@PROJECT_ROOT/assets/responsive-frontend/js/services/AfterContentComponent';
import initMobileFixedButtonsWhereSearchAlreadyExistOnPage from '@PROJECT_ROOT/assets/responsive-frontend/js/services/initMobileFixedButtonsWhereSearchAlreadyExistOnPage';
import { PageContextProvider } from '@PROJECT_ROOT/assets/responsive-frontend/js/contexts/PageContext';

const home = document.getElementById(pageConfig.homePage.id);
if (home) {
    const ssrData = window.SSR_DATA || null;
    const ssrParameters = window.SSR_PARAMETERS || null;
    const ssrSearchForm = window.SSR_SEARCH_FORM || null;
    const ssrSecondaryData = window.SSR_SECONDARY_DATA || null;
    const ssrLastMinuteOffers = window.SSR_LAST_MINUTE_OFFERS || null;

    hydrateRoot(
        home,
        <>
            <GlobalPageComponents />
            <PageContextProvider userJWT={ssrParameters?.userJWT}>
                <HomeContent
                    publicResourcesSSR={ssrData}
                    secondaryDataSSR={ssrSecondaryData}
                    ssrParameters={ssrParameters}
                    ssrSearchForm={ssrSearchForm}
                    lastMinuteOffersDataSSR={ssrLastMinuteOffers}
                />
            </PageContextProvider>
        </>,
    );
}
initAfterContentComponent();
initMobileFixedButtonsWhereSearchAlreadyExistOnPage();
